import { actions } from './conclusions/actions'
import { getters } from './conclusions/getters'
import { state } from './conclusions/state'
import { mutations } from './conclusions/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}
